module.exports = __webpack_public_path__ + "static/img/003.815b8b1.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banner/003.jpeg
// module id = lG0C
// module chunks = 11